// Catálogo de permisos por categorías (sin duplicados)
// Orden: :view primero en cada módulo, luego alfabético.

export const PERMISSION_CATEGORIES = [
  {
    id: "agenda",
    title: "AGENDA",
    perms: ["agenda:view"],
  },
  {
    id: "gestion",
    title: "GESTIÓN OPERATIVA",
    perms: [
      "gestion:view",
      "gestion.tareas:create",
      "gestion.tareas:update",
      "gestion.proyectos:create",
      "gestion.proyectos:update",
      "gestion.supervision:view",
      "gestion.reportes:view",
    ],
  },
  {
    id: "asistencia",
    title: "ASISTENCIA / RRHH",
    perms: [
      "asistencia:view",
      "asistencia:asignacion.manage",
      "asistencia:concepto.manage",
      "asistencia:dashboard.view",
      "asistencia:evento.manage",
      "asistencia:fingerprint.manage",
      "asistencia:horario.manage",
      "asistencia:jornada.manage",
      "asistencia:parametro.manage",
      "asistencia:planificacion.manage",
      "asistencia:vacacion.view",
    ],
  },
  {
    id: "config",
    title: "CONFIGURACIÓN",
    perms: [
      "config:view",
      "config:users.create",
      "config:users.list",
      "config:bancos.view",
      "config:categoriasAnimales.view",
      "config:tarjetasComunes.view",
      "config:tarjetaPlanes.view",
      "config:empresas.view",
      "config:formasPago.view",
      "config:frigorificos.view",
      "config:imputacionesContables.view",
      "config:marcasTarjeta.view",
      "config:tiposTarjeta.view",
      "config:tiposComprobantes.view",
      "config:ptosVenta.view",
      "config:proveedores.view",
      "config:proyectos.view",
      "config:periodos.view",
      "config:sync.run",
      "config:registros.view",
    ],
  },
  {
    id: "doc",
    title: "DOCUMENTACIÓN",
    perms: ["doc:view", "doc:create", "doc:categorias", "doc:subcategorias"],
  },
  {
    id: "facturacion",
    title: "FACTURACIÓN",
    perms: [
      "facturacion:view",
      "facturacion:ventas.clientes.view",
      "facturacion:ventas.facturar",
      "facturacion:compras.proveedores.view",
      "facturacion:compras.facturar",
      "facturacion:compras.pagos",
      "facturacion:compras.ctacte.view",
      "facturacion:compras.situacionFinanciera.view",
    ],
  },
  {
    id: "gmedias",
    title: "GESTIÓN DE MEDIAS",
    perms: [
      "gmedias:view",
      "gmedias:registro.view",
      "gmedias:venta.create",
      "gmedias:venta.view",
      "gmedias:producto.create",
      "gmedias:producto.view",
      "gmedias:producto.update",
      "gmedias:producto.update.tropa",
      "gmedias:producto.verify.tropa",
      "gmedias:sucursal.view",
      "gmedias:cliente.create",
      "gmedias:cliente.view",
      "gmedias:formaPago.create",
      "gmedias:formaPago.view",
      "gmedias:cobranza.view",
      "gmedias:ctacte.registros",
      "gmedias:ctacte.view",
      "gmedias:stock.view",
      "gmedias:stock.central.view",
      "gmedias:orden.create",
      "gmedias:orden.view",
      "gmedias:orden.import.excel",
      "gmedias:ingreso.create",
      "gmedias:ingreso.view",
      "gmedias:ingreso.productos.view",
    ],
  },
  {
    id: "infosuc",
    title: "INFO SUCURSALES",
    perms: ["infosuc:view"],
  },
  {
    id: "inteligencia",
    title: "INTELIGENCIA COMERCIAL",
    perms: [
      "inteligencia:view",
    ],
  },
  {
    id: "inventario",
    title: "INVENTARIO",
    perms: [
      "inventario:inventarios.view",
      "inventario:inventarios.create",
      "inventario:movimientosInternos.view",
      "inventario:movimientosOtros.view",
      "inventario:movimientosOtros.create",
      "inventario:stock.control.view",
    ],
  },
  {
    id: "iva",
    title: "IVA",
    perms: [
      "iva:view",
      "iva:libro.create",
      "iva:libro.view",
      "iva:compras.proyectadas.view",
      "iva:proyeccion.view",
    ],
  },
  {
    id: "mantenimiento",
    title: "MANTENIMIENTO",
    perms: [
      "mantenimiento:view",
      "mantenimiento:view.equipos",
      "mantenimiento:view.mantenimientos",
      "mantenimiento:view.ordenes",
      "mantenimiento:view.preventivo",
    ],
  },
  {
    id: "inspecciones",
    title: "INSPECCIONES",
    perms: [
      "inspecciones:view",
      "inspecciones:create",
      "inspecciones:edit",
      "inspecciones:review",
      "inspecciones:reportes",
      "inspecciones:admin",
    ],
  },

  {
    id: "evaluacion",
    title: "EVALUACIÓN DE DESEMPEÑO",
    perms: [
      "evaluacion:view",
      "evaluacion:create",
      "evaluacion:update",
      "evaluacion:delete",
      "evaluacion:respond",
      "evaluacion:finalize",
      "evaluacion:reportes",
      "evaluacion:dashboard",
      "evaluacion:metas",
      "evaluacion:config",
      "evaluacion:admin",
    ],
  },
  {
    id: "notification",
    title: "CENTRO DE NOTIFICACIONES",
    perms: [
      "notification:view",
      "notification:config",
      "notification:eventos",
      "notification:plantillas",
      "notification:historial",
      "notification:admin",
    ],
  },
  {
    id: "scheduler",
    title: "SCHEDULER",
    perms: [
      "scheduler:view",
      "scheduler:jobs",
      "scheduler:run",
      "scheduler:admin",
    ],
  },
  {
    id: "permisos",
    title: "PERMISOS / SEGURIDAD",
    perms: ["permisos:view"],
  },
  {
    id: "rinde",
    title: "RINDE",
    perms: [
      "rinde:formula.view",
      "rinde:formula.create",
      "rinde:percent.view",
      "rinde:percent.update",
      "rinde:prices.view",
      "rinde:prices.update",
      "rinde:calculo.run",
      "rinde:list.view",
      "rinde:list.comparative.view",
    ],
  },
  {
    id: "rindeGeneral",
    title: "RINDE GENERAL",
    perms: [
      "rindeGeneral:list.view",
      "rindeGeneral:list.global.view",
      "rindeGeneral:calculo.run",
    ],
  },
  {
    id: "rrhh",
    title: "RRHH (Alias Asistencia)",
    perms: ["rrhh:view"],
  },
  {
    id: "stats",
    title: "ESTADÍSTICAS / STATS",
    perms: [
      "statics:view",
      "stats:prices.historic.view",
      "stats:sales.comparative.view",
      "stats:sales.range.view",
      "stats:sales.chart.view",
      "stats:sales.total.view",
      "stats:sales.byCustomer.view",
      "stats:sales.deleted.view",
      "stats:sales.discount.view",
      "stats:sales.byArticle.view",
      "stats:sales.byUser.view",
      "stats:sales.kgByBranch.view",
      "stats:sales.ticketCount.view",
      "stats:inventory.stock.view",
    ],
  },
  {
    id: "sueldos",
    title: "SUELDOS",
    perms: [
      "sueldos:view",
      "sueldos:telefono.assign",
      "sueldos:datosEmpleado.assign",
      "sueldos:adicionalFijo.tipo.manage",
      "sueldos:adicionalFijo.assign",
      "sueldos:recibo.items.import",
      "sueldos:variables.import",
      "sueldos:variables.view",
      "sueldos:liquidacion.run",
      "sueldos:pago.tesoreria",
      "sueldos:adelantos.tesoreria",
      "sueldos:prestamos.tesoreria",
    ],
  },
  {
    id: "tesoreria",
    title: "TESORERÍA",
    perms: [
      "tesoreria:view",
      "tesoreria:categoria.manage",
      "tesoreria:caja.open",
      "tesoreria:caja.view",
      "tesoreria:retiros.view",
      "tesoreria:banco.view",
      "tesoreria:banco.import",
      "tesoreria:tarjeta.view",
      "tesoreria:cheque.view",
      "tesoreria:gastosEstimados.view",
      "tesoreria:gastosEstimados.import",
      "tesoreria:vencimientos.view",
      "tesoreria:info.cajas.view",
      "tesoreria:info.gastos.view",
      "tesoreria:info.retiros.view",
      "tesoreria:info.vales.view",
      "tesoreria:info.cupones.view",
      "tesoreria:info.sueldos.view",
      "tesoreria:info.ingresos.view",
      "tesoreria:info.cierresZ.view",
      "tesoreria:info.ctacte.cliente.view",
      "tesoreria:info.ctacte.sucursal.view",
      "tesoreria:info.ctacte.detalle.view",
      "tesoreria:info.caja.detalle.view",
    ],
  },
  {
    id: "fidelizacion",
    title: "COMERCIOS AMIGOS / FIDELIZACIÓN",
    perms: [
      "fidelizacion:view",
      "fidelizacion:manage",
      "fidelizacion:comercios",
      "fidelizacion:campanias",
      "fidelizacion:premios",
      "fidelizacion:cupones",
      "fidelizacion:puntos",
      "fidelizacion:premiosComercio",
      "fidelizacion:canjesComercio",
      "fidelizacion:fraude",
    ],
  },

  {
    id: "motorconceptos",
    title: "MOTOR DE CONCEPTOS",
    perms: [

      "motorconceptos:view",
      "motorconceptos:create",
      "motorconceptos:update",
      "motorconceptos:delete",
      "motorconceptos:config",

      "motorconceptos:registros.view",
      "motorconceptos:registros.create",
      "motorconceptos:registros.update",
      "motorconceptos:registros.delete",

      "motorconceptos:vencimientos.view",

      // Gestión Documental

      "motorconceptos:gestion.empleados.view",
      "motorconceptos:gestion.empresas.view",
      "motorconceptos:gestion.sucursales.view",

      // Asignaciones

      "motorconceptos:asignaciones.view",
      "motorconceptos:asignaciones.create",
      "motorconceptos:asignaciones.update",
      "motorconceptos:asignaciones.delete",

    ],
  },

  {
    id: "legajos",
    title: "LEGAJOS",
    perms: [
      "legajos:view",

      "legajos:conceptos.view",

      "legajos:registros.view",

      "legajos:gestion.empleados.view",

      "legajos:gestion.empresas.view",

      "legajos:gestion.sucursales.view",
    ],
  },

];

// Utilidades
export const FLAT_PERMISSIONS = Array.from(
  new Set(PERMISSION_CATEGORIES.flatMap((c) => c.perms))
);
